export default function getMarginLeftLg(value) {
  switch (value) {
    case -44:
      return "lg:-ml-44";
    case -40:
      return "lg:-ml-40";
    case -36:
      return "lg:-ml-36";
    case -32:
      return "lg:-ml-32";
    case -28:
      return "lg:-ml-28";
    case -24:
      return "lg:-ml-24";
    case -20:
      return "lg:-ml-20";
    case -16:
      return "lg:-ml-16";
    case -12:
      return "lg:-ml-12";
    case -8:
      return "lg:-ml-8";
    case -4:
      return "lg:-ml-4";
    case 0:
      return "lg:ml-0";
    case 1:
      return "lg:ml-1";
    case 2:
      return "lg:ml-2";
    case 3:
      return "lg:ml-3";
    case 4:
      return "lg:ml-4";
    case 5:
      return "lg:ml-5";
    case 6:
      return "lg:ml-6";
    case 7:
      return "lg:ml-7";
    case 8:
      return "lg:ml-8";
    case 9:
      return "lg:ml-9";
    case 10:
      return "lg:ml-10";
    case 12:
      return "lg:ml-12";
    case 14:
      return "lg:ml-14";
    case 16:
      return "lg:ml-16";
    case 20:
      return "lg:ml-20";
    case 24:
      return "lg:ml-24";
    default:
      return "";
  }
}
